module.exports = __webpack_public_path__ + "media/images/customized-targeting-4d0ee2e6595832522d9d1fd9148f7864.png";